__webpack_require__.p = "https://msvcweuwebsiteprod.azureedge.net/bundles/frontend/dist/wolf/";